module.exports = __webpack_public_path__ + "static/media/pokedex_top.f7e3f51e.png";